import React, { useEffect, useState } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  createTheme,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  InputAdornment,
  MenuItem,
  Modal,
  Snackbar,
  TextField,
  ThemeProvider,
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers";
import { CheckBox, CheckBoxOutlineBlank } from "@mui/icons-material";
import dayjs from "dayjs";
import api from "../axiosConfig";
import { useModalContext } from "../ModalContext";
import {
  getCurrentMonthDatesAsia,
  getDatesFromMonthYearAsia,
  getUser,
} from "../helpers";
import { LoadingButton } from "@mui/lab";

function AddNewScheme({
  newSchemeModalOpen,
  setNewSchemeModalOpen,
  handleCloseModal02,
  callValue,
  schemeTypeData,
  setCallValue,
  editValue,
  rowColumn,
  monthYear,
  handleClose,
  setEditValue,
  page,
  updateRowData,
  selectedDate,
  modalformData,
  modalsetFormData,
  clickedDate,
  schemeContinue = false,
}) {
  const [errors, setErrors] = useState({});
  const [openNotificationText, setNotificationText] = useState("");
  // const [selectedWarehouse, setSelectedWarehouse] = useState([]);
  // const [selectedChannel, setSelectedChannel] = useState([]);
  // const [selectedCategory, setSelectedCategory] = useState([]);
  // const [selectedProduct, setSelectedProduct] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [pricelistOptions, setPricelistOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [openNotification, setNotification] = useState(false);
  const [adjustWithExistingQty, setAdjustWithExistingQty] = useState(0);
  const [updateLoading, SetUpdateLoading] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const {
    customOpenModal,
    setCustomOpenModal,
    openModalWithAGValues02,
    currency,
  } = useModalContext();
  const user = getUser();
  useEffect(() => {
    if (callValue?.Warehouse) {
      modalsetFormData((prev) => ({
        ...prev,
        warehouse: callValue?.Warehouse,
        channel: callValue?.OutletType,
        pricelist: callValue?.Pricelist,
        productName: callValue?.Product_Name,
        product: callValue?.ProductCode,
      }));
    }
  }, [callValue]);

  useEffect(() => {
    if (schemeTypeData?.type) {
      modalsetFormData((prev) => ({
        ...prev,
        schemeType: schemeTypeData.type,
      }));
    }
  }, [schemeTypeData]);

  useEffect(() => {
    if (editValue?.length > 0) {
      let requestType = {
        "On Invoice": "OnInv",
        "Off Invoice": "OffInv",
        Visibility: "Visibility",
      };
      const onInv =
        editValue.find((item) => item.Request_Type === "OnInv") || {};
      const offInv =
        editValue.find((item) => item.Request_Type === "OffInv") || {};
      const visibility =
        editValue.find((item) => item.Request_Type === "Visibility") || {};
      const editValueObj = editValue.find(
        (item) => item.Request_Type === requestType[schemeTypeData?.type]
      );

      modalsetFormData((prev) => {
        const isOnInv = schemeTypeData.type === "On Invoice";
        const isVisibility = schemeTypeData.type === "Visibility";
        // Determine the quantity impact source based on scheme type
        const quantityImpactSource = isOnInv
          ? onInv.Qty_Impact
          : isVisibility
          ? visibility.Qty_Impact
          : offInv.Qty_Impact;

        // Determine the scheme impact value based on scheme type
        const schemeImpactSource = isVisibility
          ? visibility.Sales
          : schemeTypeData.revValue;

        return {
          ...prev,
          rateImpact: isOnInv
            ? Math.round((onInv.Rate_Impact ?? prev.rateImpact) * 100)
            : prev.rateImpact,

          quantityImpact: Math.round(
            (quantityImpactSource ?? prev.quantityImpact) * 100
          ),

          schemeImpactValue: Math.round(
            schemeImpactSource ?? prev.schemeImpactValue
          ),
          mrpRate: editValueObj?.mrpRate,
        };
      });
    }
  }, [editValue, schemeTypeData]);

  //   Fetch dropdown options from API
  useEffect(() => {
    // Mock API fetch
    setWarehouseOptions(["Warehouse 1", "Warehouse 2", "Warehouse 3"]);
    setPricelistOptions(["Pricelist 1", "Pricelist 2", "Pricelist 3"]);
  }, []);

  useEffect(() => {
    if (openNotification) {
      const timer = setTimeout(() => {
        setNotification(false);
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [openNotification]);

  const mrpRate = [
    { MrpValue: "MRP", name: "MRP" },
    { MrpValue: "PTR", name: "PTR" },
  ];

  // const handleCloseModal = () => {
  //   // setNewSchemeModalOpen(false);
  //   setSelectedWarehouse([]);
  //   setSelectedProduct([]);
  //   setSelectedCategory([]);
  //   setSelectedChannel([]);
  //   modalsetFormData([]);
  //   // setEditingRow(null);
  //   // setEditingColumn('');
  //   // setEditingValue('');
  //   resetForm();
  // };

  const resetForm = () => {
    modalsetFormData({
      schemeName: "",
      schemeStartDate: null,
      schemeEndDate: null,
      warehouse: [],
      channel: [],
      pricelist: [],
      productName: [],
      product: [],
      schemeType: "",
      rateImpact: "",
      quantityImpact: "",
      schemeImpactValue: "",
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    modalsetFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear the field-specific error if valid input is entered
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "", // Clear error for the specific field being updated
    }));

    if (openNotification) {
      setNotification(false);
      setNotificationText("");
    }
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false); // Close the snackbar
  };

  const handleCheckboxChange = (event) => {
    setAdjustWithExistingQty(event.target.checked ? 1 : 0);
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    // Required fields validation
    if (!modalformData.schemeName)
      newErrors.schemeName = "Scheme Name is required.";

    if (!modalformData.schemeEndDate) {
      modalformData.schemeEndDate = modalformData.schemeStartDate; // Set to start date if not explicitly set
    }

    if (!modalformData.schemeStartDate) {
      if (!isNaN(Number(selectedDate))) {
        modalformData.schemeStartDate = dayjs(
          new Date(monthYear.year(), monthYear.month(), selectedDate)
        ).format("YYYY-MM-DD");
      } else {
        newErrors.schemeStartDate = "Scheme Start Date is required.";
      }
    }
    if (!modalformData.schemeEndDate) {
      if (!isNaN(Number(selectedDate))) {
        modalformData.schemeEndDate = dayjs(
          new Date(monthYear.year(), monthYear.month(), selectedDate)
        ).format("YYYY-MM-DD");
      } else {
        newErrors.schemeEndDate = "Scheme Start Date is required.";
      }
    }

    // Conditional validations
    if (["On Invoice"].includes(modalformData.schemeType)) {
      if (!modalformData.mrpRate) {
        newErrors.mrpRate = "Discount On is required for 'On Invoice' schemes.";
      }
      if (!modalformData.rateImpact) {
        newErrors.rateImpact =
          "Rate Impact is required for 'On Invoice' schemes.";
      }
    }
    if (
      ["On Invoice", "Off Invoice", "Visibility"].includes(
        modalformData.schemeType
      ) &&
      !modalformData.quantityImpact
    ) {
      newErrors.quantityImpact = "Quantity Impact is required.";
    }
    if (
      ["Visibility"].includes(modalformData.schemeType) &&
      !modalformData.schemeImpactValue
    ) {
      newErrors.schemeImpactValue = "Scheme Impact Value is required.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // Update errors state
      console.log("Validation Errors:", newErrors); // Debugging
      return;
    }

    SetUpdateLoading(true);

    try {
      const payload = {
        ...modalformData,
        warehouse: callValue?.Warehouse || "Default Warehouse",
        channel: callValue?.OutletType || "Default Channel",
        pricelist: callValue?.Pricelist || "Default Pricelist",
        productName: callValue?.Product_Name || "Default Product Name",
        product: callValue?.ProductCode || 0,
        adjustWithExistingQty: adjustWithExistingQty || 0,
        page: page,
        user: user,
        currencyType: currency,
      };

      const response = await api.post("/api/scheme/addnew", {
        body: payload,
      });

      if (response.data.Status) {
        setSnackbarMessage(
          `${modalformData.schemeType || ""} Scheme successfully added.`
        );
        setSnackbarSeverity("success");
        setSnackbarOpen(true);

        // handleCloseModal();
        handleCloseModal02();
        setNotification(false);
        setNotificationText("");
        // Conditional handling for `openModalWithAGValues02`
        if (page === "summary") {
          openModalWithAGValues02(
            callValue,
            getDatesFromMonthYearAsia(monthYear),
            setEditValue,
            rowColumn,
            "",
            "summary"
          );
        } else if (page === "dayleveledit") {
          openModalWithAGValues02(
            callValue,
            getDatesFromMonthYearAsia(monthYear),
            setEditValue,
            rowColumn,
            selectedDate,
            "dayleveledit"
          );
        }
        updateRowData(response.data.data_updated);
        setCustomOpenModal(true);
        resetForm();
        console.log("successfully updated");
      } else {
        console.log("Scheme already exists. Setting new scheme modal open.");
        setSnackbarMessage(response.data.SchemeStatus || "An error occurred.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
        setNewSchemeModalOpen(true);
      }
      // if (!response.data.Status) {
      //   throw new Error(
      //     response.data.SchemeStatus || "An error occurred, please try again."
      //   );
      // }
    } catch (error) {
      console.error("Error adding scheme:", error);
      setSnackbarSeverity("error");
      setSnackbarMessage(
        "Scheme Already present in the System. Setting new scheme modal open."
      );
      setSnackbarOpen(true);
    } finally {
      SetUpdateLoading(false);
    }
  };

  const reOpenEditModal = () => {
    // Conditional handling for `openModalWithAGValues02`
    if (page === "summary") {
      openModalWithAGValues02(
        callValue,
        getDatesFromMonthYearAsia(monthYear),
        setEditValue,
        rowColumn,
        "",
        "summary"
      );
    } else if (page === "dayleveledit") {
      openModalWithAGValues02(
        callValue,
        getDatesFromMonthYearAsia(monthYear),
        setEditValue,
        rowColumn,
        selectedDate,
        "dayleveledit"
      );
    }
  };

  const ValidatedTextField = ({ label, name, value, onChange, error }) => (
    <TextField
      fullWidth
      label={label}
      name={name}
      value={value}
      onChange={onChange}
      error={!!error}
      helperText={error || ""}
    />
  );

  const customTheme = createTheme({
    components: {
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiInputBase-input": {
              fontSize: "14px", // Font size for the input field
            },
          },
        },
      },
      MuiPickersDay: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for the calendar days
          },
        },
      },
      MuiTypography: {
        styleOverrides: {
          root: {
            fontSize: "12px", // Font size for typography inside the Date Picker
          },
        },
      },
    },
  });

  return (
    <>
      <Modal open={newSchemeModalOpen}>
        <Box
          sx={{
            bgcolor: "background.paper",
            maxWidth: 682,
            maxHeight: "80vh",
            overflowY: "auto",
            mx: "auto",
            marginTop: "40px",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#F4F4F4",
              padding: "24px",
              position: "sticky",
              top: 0,
              zIndex: 10,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#000",

                margin: "0",
              }}
            >
              Create Scheme
            </h2>
          </Box>

          <Box
            sx={{
              padding: "36px 24px 24px 24px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Scheme Name"
                  name="schemeName"
                  value={modalformData.schemeName}
                  onChange={(e) => {
                    const value = e.target.value;
                    modalsetFormData((prevData) => ({
                      ...prevData,
                      schemeName: value,
                    }));
                    if (value) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        schemeName: "",
                      }));
                    }
                  }}
                  error={Boolean(errors.schemeName)}
                  //   helperText={errors.schemeName}
                  size="small"
                />
                {errors.schemeName && (
                  <FormHelperText
                    sx={{
                      color: "#FF0000",
                      marginTop: "4px",
                    }}
                  >
                    {errors.schemeName}*
                  </FormHelperText>
                )}
              </Grid>

              <ThemeProvider theme={customTheme}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box
                    className="scheme-date-picker"
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: "20px",
                      marginTop: "20px",
                      marginLeft: "16px",
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                      }}
                    >
                      <DatePicker
                        label="Scheme Start Date"
                        sx={{ width: "100%" }}
                        // value={
                        //   modalformData.schemeStartDate
                        //     ? dayjs(modalformData.schemeStartDate)
                        //     : null
                        // }
                        // defaultCalendarMonth={dayjs(monthYear)}

                        value={
                          modalformData.schemeStartDate
                            ? dayjs(modalformData.schemeStartDate)
                            : !isNaN(Number(selectedDate))
                            ? dayjs(
                                new Date(
                                  monthYear.year(),
                                  monthYear.month(),
                                  selectedDate
                                )
                              )
                            : null
                        }
                        onChange={(newValue) => {
                          modalsetFormData((prevData) => ({
                            ...prevData,
                            schemeStartDate: newValue
                              ? newValue.format("YYYY-MM-DD")
                              : "",
                          }));
                          if (newValue) {
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              schemeStartDate: "",
                            }));
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            margin="normal"
                            error={Boolean(errors.schemeStartDate)}
                          />
                        )}
                        disablePast={true}
                        minDate={monthYear.startOf("month")}
                        maxDate={monthYear.endOf("month")}
                        // shouldDisableDate={(date) => {
                        //   const dayjsDate = dayjs(date); // Convert to Day.js instance
                        //   // const startOfMonth = monthYear.startOf("month");
                        //   // const endOfMonth = monthYear.endOf("month");
                        //   const today = dayjs().startOf("day");
                        //   const tomorrow = today.add(1, "day");
                        //   const endDate = modalformData.schemeEndDate
                        //     ? dayjs(modalformData.schemeEndDate)
                        //     : null;

                        //   return (
                        //     dayjsDate.isBefore(
                        //       monthYear.startOf("month"),
                        //       "day"
                        //     ) ||
                        //     dayjsDate.isAfter(
                        //       monthYear.endOf("month"),
                        //       "day"
                        //     ) ||
                        //     dayjsDate.isSame(today, "day") ||
                        //     dayjsDate.isSame(tomorrow, "day") ||
                        //     // dayjsDate.isBefore(startOfMonth, "day") ||
                        //     // dayjsDate.isAfter(endOfMonth, "day") ||
                        //     (endDate && dayjsDate.isAfter(endDate, "day"))
                        //   );
                        // }}
                        openTo="day" // Ensure it opens to the day view
                        defaultCalendarMonth={monthYear}
                        disabled={isNaN(Number(selectedDate)) === false}
                      />
                      {errors.schemeStartDate && (
                        <FormHelperText
                          sx={{
                            color: "#FF0000",
                            marginTop: "4px",
                          }}
                        >
                          {errors.schemeStartDate}*
                        </FormHelperText>
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "50%",
                      }}
                    >
                      <DatePicker
                        label="Scheme End Date"
                        sx={{ width: "100%" }}
                        // value={
                        //   modalformData.schemeEndDate
                        //     ? dayjs(modalformData.schemeEndDate)
                        //     : null
                        // }
                        value={
                          modalformData.schemeStartDate
                            ? dayjs(modalformData.schemeStartDate)
                            : !isNaN(Number(selectedDate))
                            ? dayjs(
                                new Date(
                                  monthYear.year(),
                                  monthYear.month(),
                                  selectedDate
                                )
                              )
                            : null
                        }
                        onChange={(newValue) => {
                          modalsetFormData((prevData) => ({
                            ...prevData,
                            schemeEndDate: newValue
                              ? newValue.format("YYYY-MM-DD")
                              : "",
                          }));
                          if (newValue) {
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              schemeEndDate: "",
                            }));
                          }
                        }}
                        renderInput={(params) => (
                          <TextField {...params} fullWidth margin="normal" />
                        )}
                        disablePast={true}
                        minDate={monthYear.startOf("month")} // Start of the selected month
                        maxDate={monthYear.endOf("month")}
                        // shouldDisableDate={(date) => {
                        //   const dayjsDate = dayjs(date); // Convert to Day.js instance
                        //   const today = dayjs().startOf("day");
                        //   const tomorrow = today.add(1, "day");
                        //   const startDate = modalformData.schemeStartDate
                        //     ? dayjs(modalformData.schemeStartDate)
                        //     : dayjs().startOf("day");
                        //   const startOfMonth = monthYear.startOf("month");
                        //   const endOfMonth = monthYear.endOf("month");

                        //   return (
                        //     dayjsDate.isBefore(
                        //       monthYear.startOf("month"),
                        //       "day"
                        //     ) ||
                        //     dayjsDate.isAfter(
                        //       monthYear.endOf("month"),
                        //       "day"
                        //     ) ||
                        //     dayjsDate.isSame(today, "day") ||
                        //     dayjsDate.isSame(tomorrow, "day") ||
                        //     // dayjsDate.isBefore(startOfMonth, "day") ||
                        //     // dayjsDate.isAfter(endOfMonth, "day") ||
                        //     dayjsDate.isBefore(startDate, "day")
                        //   );
                        // }}
                        openTo="day" // Ensure it opens to the day view
                        defaultCalendarMonth={monthYear}
                        disabled={isNaN(Number(selectedDate)) === false}
                      />
                      {errors.schemeEndDate && (
                        <FormHelperText
                          sx={{
                            color: "#FF0000",
                            marginTop: "4px",
                          }}
                        >
                          {errors.schemeEndDate}*
                        </FormHelperText>
                      )}
                    </Box>
                  </Box>
                </LocalizationProvider>
              </ThemeProvider>

              <Grid item xs={6}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    disabled
                    label="Warehouse"
                    name="Warehouse"
                    value={callValue?.Warehouse}
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid item xs={6} sx={{ marginTop: "5px" }}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    disabled
                    label="Channel"
                    name="OutletType"
                    value={callValue?.OutletType}
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    disabled
                    label="Pricelist"
                    name="Pricelist"
                    value={callValue?.Pricelist}
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    disabled
                    label="Product"
                    name="Product"
                    value={callValue?.Product_Name}
                    size="small"
                  />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  select
                  disabled
                  label="Scheme Type"
                  name="schemeType"
                  value={modalformData.schemeType}
                  onChange={handleChange}
                  error={!!errors.schemeType}
                  helperText={errors.schemeType || ""}
                  size="small"
                >
                  {["On Invoice", "Off Invoice", "Visibility"]?.map(
                    (type, index) => (
                      <MenuItem key={index} value={type}>
                        {type}
                      </MenuItem>
                    )
                  )}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                {["On Invoice", "Off Invoice"].includes(
                  modalformData.schemeType
                ) && (
                  <TextField
                    fullWidth
                    select
                    label="Discount On"
                    name="mrpRate"
                    value={modalformData.mrpRate}
                    onChange={(e) => {
                      const value = e.target.value;
                      modalsetFormData((prevData) => ({
                        ...prevData,
                        mrpRate: value,
                      }));
                      if (value) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          mrpRate: "",
                        }));
                      }
                    }}
                    error={!!errors.mrpRate}
                    helperText={errors.mrpRate || ""}
                    size="small"
                  >
                    {mrpRate?.map((rate, index) => (
                      <MenuItem key={index} value={rate.MrpValue}>
                        {rate.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              </Grid>

              {/* Conditionally render Rate Impact and Quantity Impact based on Scheme Type */}
              {["On Invoice", "Off Invoice"].includes(
                modalformData.schemeType
              ) && (
                <>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      label="Rate Impact (-) %"
                      name="rateImpact"
                      value={modalformData.rateImpact}
                      error={!!errors.rateImpact} // Show red border if there’s an error
                      helperText={errors.rateImpact || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        const numericValue = value.replace(/[^0-9.]/g, "");
                        modalsetFormData((prevData) => ({
                          ...prevData,
                          rateImpact: numericValue,
                        }));
                        if (numericValue) {
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            rateImpact: "", // Clear error when input is valid
                          }));
                        }
                      }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </Grid>
                </>
              )}

              {["On Invoice", "Off Invoice", "Visibility"].includes(
                modalformData.schemeType
              ) && (
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Quantity Impact in %"
                    name="quantityImpact"
                    value={modalformData.quantityImpact}
                    error={!!errors.quantityImpact}
                    helperText={errors.quantityImpact || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      const numericValue = value.replace(/[^0-9.]/g, "");
                      modalsetFormData((prevData) => ({
                        ...prevData,
                        quantityImpact: numericValue,
                      }));
                      if (numericValue) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          quantityImpact: "",
                        }));
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">%</InputAdornment>
                      ),
                    }}
                    size="small"
                  />
                </Grid>
              )}

              {["Visibility"].includes(modalformData.schemeType) && (
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Scheme Impact Value"
                    name="schemeImpactValue"
                    value={modalformData.schemeImpactValue}
                    error={!!errors.schemeImpactValue}
                    helperText={errors.schemeImpactValue || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      modalsetFormData((prevData) => ({
                        ...prevData,
                        schemeImpactValue: value,
                      }));
                      if (value) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          schemeImpactValue: "", // Clear error when input is valid
                        }));
                      }
                    }}
                    size="small"
                  />
                </Grid>
              )}
            </Grid>
            {["On Invoice", "Off Invoice"].includes(
              modalformData.schemeType
            ) && (
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      size="small"
                      checked={adjustWithExistingQty === 1}
                      onChange={handleCheckboxChange}
                      sx={{
                        color: "#149485",
                        "&.Mui-checked": {
                          color: "#149485",
                          width: "fit-content",
                        },
                      }}
                    />
                  }
                  label="Adjust with existing qty"
                  sx={{
                    "& .MuiFormControlLabel-label": {
                      fontSize: "14px", // Set font size for the label
                    },
                  }}
                />
              </FormGroup>
            )}

            <br></br>

            {openNotification && (
              <Alert
                severity="warning"
                onClose={() => setNotification(false)}
                sx={{
                  backgroundColor: "#FFA500",
                  color: "#fff",
                }}
              >
                {openNotificationText}
              </Alert>
            )}

            <Box sx={{ textAlign: "right" }}>
              <LoadingButton
                variant="contained"
                loading={updateLoading}
                loadingPosition="end"
                color="primary"
                onClick={handleCreateSubmit}
                style={{
                  fontSize: "12px",
                  backgroundColor: updateLoading ? "#16a69590" : "#16a695",
                  paddingRight: updateLoading ? "35px" : "",
                  color: "white",
                }}
                size="small"
              >
                {updateLoading ? "Updating..." : "Update New Scheme"}
              </LoadingButton>
              &nbsp;&nbsp;&nbsp;
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setCustomOpenModal(true);
                  reOpenEditModal();
                  handleCloseModal02();
                  resetForm();
                }}
                style={{
                  fontSize: "12px",
                  color: "#000",
                  background: "#fff",
                  border: "1px solid #707070",
                }}
                size="small"
              >
                Close
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}

export default AddNewScheme;
